import { Lightbulb, PiggyBank, Star, ShoppingCart, Package, ChefHat, Wallet } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';

export const TipCard = ({ tip }) => {
    const categoryConfig = {
        shopping: { icon: ShoppingCart, color: 'green', label: 'Courses' },
        storage: { icon: Package, color: 'cyan', label: 'Conservation' },
        cooking: { icon: ChefHat, color: 'orange', label: 'Cuisine' },
        budget: { icon: Wallet, color: 'purple', label: 'Budget' }
    };
    
    const config = categoryConfig[tip.category] || { icon: Lightbulb, color: 'green', label: tip.category };
    const IconComponent = config.icon;
    
    const colorStyles = {
        green: {
            card: 'border-green-500 shadow-[6px_6px_0px_0px_hsl(150,100%,40%)]',
            icon: 'bg-green-500',
            badge: 'bg-green-100 text-green-700 border-green-400'
        },
        cyan: {
            card: 'border-cyan-500 shadow-[6px_6px_0px_0px_#06b6d4]',
            icon: 'bg-cyan-500',
            badge: 'bg-cyan-100 text-cyan-700 border-cyan-400'
        },
        orange: {
            card: 'border-orange-500 shadow-[6px_6px_0px_0px_hsl(25,100%,50%)]',
            icon: 'bg-orange-500',
            badge: 'bg-orange-100 text-orange-700 border-orange-400'
        },
        purple: {
            card: 'border-purple-500 shadow-[6px_6px_0px_0px_hsl(270,80%,50%)]',
            icon: 'bg-purple-500',
            badge: 'bg-purple-100 text-purple-700 border-purple-400'
        }
    };
    
    const styles = colorStyles[config.color];

    return (
        <Card 
            className={`group overflow-hidden bg-white rounded-3xl border-2 ${styles.card} transition-all duration-300 hover:-translate-y-2 hover:rotate-1`}
            data-testid={`tip-card-${tip.id}`}
        >
            <CardContent className="p-6">
                <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-3">
                        <div className={`w-14 h-14 rounded-2xl ${styles.icon} flex items-center justify-center border-2 border-foreground`}>
                            <IconComponent className="w-7 h-7 text-white" />
                        </div>
                        <div>
                            <Badge className={`text-xs font-bold border-2 ${styles.badge}`}>
                                {config.label}
                            </Badge>
                            {tip.is_premium && (
                                <Badge className="ml-2 bg-gradient-to-r from-yellow-400 to-orange-400 text-foreground text-xs font-bold border-2 border-foreground">
                                    <Star className="w-3 h-3 mr-1" />
                                    Premium
                                </Badge>
                            )}
                        </div>
                    </div>
                </div>
                
                <h3 className="font-heading font-bold text-xl text-foreground mb-3 group-hover:text-primary transition-colors">
                    {tip.title}
                </h3>
                
                <p className="text-muted-foreground leading-relaxed mb-4">
                    {tip.content}
                </p>
                
                {tip.savings_estimate && (
                    <div className="flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full font-bold text-sm border-2 border-green-400 w-fit">
                        <PiggyBank className="w-4 h-4" />
                        <span>Économie: {tip.savings_estimate}</span>
                    </div>
                )}
            </CardContent>
        </Card>
    );
};

export default TipCard;
